export default __webpack_public_path__ + "static/media/empty-state-mel.f101c57c.svg";